var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navbar_history") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-294, -26)",
    stroke: "#0E1C39",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(298, 28)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.80489607,
    y1: 4.16656239,
    x2: 11.3320247,
    y2: 4.16656239,
    id: "\\u8DEF\\u5F84-8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.80489607,
    y1: 7.66656239,
    x2: 9.3320247,
    y2: 7.66656239,
    id: "\\u8DEF\\u5F84-8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 13,
    cy: 15,
    r: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "12 12.3 12 15.2981518 15 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,8 L17,3 C17,1.34314575 15.6568542,-4.05812251e-16 14,0 L3,0 C1.34314575,3.04359188e-16 1.39730022e-16,1.34314575 4.4408921e-16,3 L0,17 C2.02906125e-16,18.6568542 1.34314575,20 3,20 C4.33333333,20 5.66666667,20 7,20",
    id: "\\u8DEF\\u5F84-10",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarHistory);
export default __webpack_public_path__ + "static/media/navbar_history.326fdd296ddac3d107f85ba2ce882a9f.svg";
export { ForwardRef as ReactComponent };